import { RaisedButton } from 'material-ui';
import React from 'react';

function OpenMailBlock({mailId}) {
    return (
        <div className='paper-block'>
            <div className='name-block absolute small-name'>email</div>
            <span>Id: {mailId}</span>
            <RaisedButton
                onClick={() => window.open(`/${mailId}`, "_blank")}
                label='Open Mail'
                style={{ marginLeft: '20px' }}
                primary
            />
        </div>
    );
}

export default OpenMailBlock;



// WEBPACK FOOTER //
// ./app/components/Base/Mails/OpenMailBlock.jsx